export function getQueryParam(name: string): string | undefined {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get(name) || undefined;
}

export function getIdQueryParam<T extends number>(name: string): T | undefined {
  const param = getQueryParam(name);
  if (!param) return undefined;

  return parseInt(param, 10) as T;
}

export function setSearchParamsInUrl(params: Record<string, any>) {
  const url = new URL(window.location.href);
  url.search = ''; // clear existing filter params
  Object.entries(params).forEach(([key, value]) => {
    // omit blanks and false booleans so the URL stays clean and round-trips correctly
    if (value === '' || value === null || value === undefined || value === false) return;
    url.searchParams.set(key, String(value));
  });
  history.replaceState({}, '', url);
}
